import React, { useEffect, useState } from 'react';
import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import { useParams } from 'react-router';
import { Col, Divider, Form, Row } from 'antd';
import { saveData, fetchData } from '../../service/dataServices';
import moment from 'moment';
import { getFormItems } from '../../components/form/formComponents';
import { getOperationType, rowStyle } from '../../components/common-constants';
import { hasWritePermission } from '../../../components/Authorization/hasWritePermission';

const SaveObject = () => {
  const PATH = '/api/objects';
  const { id } = useParams();
  const operation = getOperationType(id);
  const hasWritePerm = hasWritePermission("item");

  const [form] = Form.useForm();
  const [initialOtherDimensions, setInitialOtherDimensions] = useState([]);
  const [mainImageFileList, setMainImageFileList] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [initialData, setInitialData] = useState();
  const [dropdowns, setDropdowns] = useState();
  const [availability, setAvailability] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  fetchData('/api/dropdowns', setDropdowns);
  if (id) {
    fetchData(PATH + '/' + id, setInitialData);
  }
  const saveMutation = saveData(PATH, operation.method);

  useEffect(() => {
    if (initialData && dropdowns) {
      setInitialOtherDimensions(initialData.otherDimensions || []);
      if (initialData.mainImage) setMainImageFileList([initialData.mainImage]);
      if (initialData.imageList) setImageList(initialData.imageList);
      if (initialData.dropdowns && initialData.dropdowns.classification && dropdowns.classification) {
        const found = dropdowns.classification.find(dd => dd.id === initialData.dropdowns.classification);
        if (found && found.children) setCategoryList(found.children);
      }
      form.setFieldsValue({
        ...initialData,
        registrationDate: initialData.registrationDate ? moment(initialData.registrationDate) : null,
        date: initialData.date ? moment(initialData.date) : null,
      });
    }
  }, [initialData, dropdowns]);

  const onFinish = (values) => {
    const dataToSend = {
      ...values,
      mainImage: mainImageFileList ? mainImageFileList[0] : undefined,
      imageList: imageList ? imageList : undefined,
    };
    if (id) {
      saveMutation.mutate({ dataToSend, id });
    } else {
      saveMutation.mutate({ dataToSend });
    }
  };

  const onAvailability = (values) => {
    form.setFieldsValue({ available: values });
    setAvailability(values);
    if (values === true) {
      form.setFieldsValue({dropdowns: {availabilityPurpose: undefined }})
    }
  };

  const {
    getDropdownFormItem,
    getMultiselectFormItem,
    getInputFormItem,
    getInputNumberFormItem,
    getDatePickerFormItem,
    getImageListFormItem,
    getMainImageFormItem,
    getTextAreaFormItem,
    getSwitchFormItem,
    getFormSubmitButton,
    getOtherDimensionsFormItems,
    getParentSelectFormItem,
    getChildSelectFormItem,
  } = getFormItems(dropdowns, hasWritePerm);

  return (
    <CustomAddNewPageContent title={operation.type + ' Object'} subTitle="Objects">
      <Form
        form={form}
        labelCol={{ span: 16 }}
        wrapperCol={{ span: 16 }}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row style={rowStyle}>
          <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
            {getMainImageFormItem('mainImage', false, 'objects', mainImageFileList, setMainImageFileList)}
          </Col>
          <Col span={16}>
            <Row>
              <Col span={12}>
                {getInputFormItem('inventoryNumber', 'Inventory Number', true)}
              </Col>
              <Col span={12}>
                {getInputFormItem('quantity', 'Quantity', false, 'number')}
              </Col>
              <Col span={12}>
                {getInputFormItem('objectName', 'Object Name')}
              </Col>
              <Col span={12}>
                {getInputFormItem('objectTitle', 'Object Title')}
              </Col>
              <Col span={12}>
                {getInputFormItem('author', 'Author')}
              </Col>

              <Col span={12}>
                {getSwitchFormItem('available', 'Availability', onAvailability)}
              </Col>

              <Col span={12} />
              <Col span={12}>
                {getDropdownFormItem('availabilityPurpose', 'Availability Purpose', availability)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider/>
        <Row style={rowStyle}>
          <Col span={8}>
            {getInputNumberFormItem('length', 'Length', 'cm')}
            {getInputNumberFormItem('width', 'Width', 'cm')}
            {getInputNumberFormItem('height', 'Height', 'cm')}
            {getInputNumberFormItem('weight', 'Weight', 'gr')}
            {getOtherDimensionsFormItems(initialOtherDimensions)}
          </Col>
          <Col span={16}>
            <Row>
              <Col span={12}>
                {getParentSelectFormItem('classification', 'Classification', setCategoryList)}
              </Col>
              <Col span={12}>
                {getChildSelectFormItem('category', 'Category', categoryList)}
              </Col>
              <Col span={12}>
                {getMultiselectFormItem('material', 'Material')}
              </Col>
              <Col span={12}>
                {getMultiselectFormItem('technique', 'Technique')}
              </Col>
              <Col span={12}>
                {getDropdownFormItem('region', 'Region')}
              </Col>
              <Col span={12}>
                {getInputFormItem('country', 'Country')}
              </Col>
              <Col span={12}>
                {getInputFormItem('city', 'City')}
              </Col>
              <Col span={12}>
                {getInputFormItem('century', 'Century')}
              </Col>
              <Col span={12}>
                {getDatePickerFormItem('date', 'Date')}
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider/>
        <Row style={rowStyle}>
          <Col span={24}>
            {getTextAreaFormItem('description', 'Description', { span: 22 })}
          </Col>
          <Col span={12}>
            {getInputFormItem('inscriptionType', 'Inscription Type')}
          </Col>
          <Col span={12}>
            {getInputFormItem('inscriptionPosition', 'Inscription Position')}
          </Col>
        </Row>
        <Divider/>
        <Row style={rowStyle}>
          <Col span={8}>
            {getDropdownFormItem('location', 'Location')}
          </Col>
          <Col span={8}>
            {getDropdownFormItem('locationArea', 'Location Area')}
          </Col>
          <Col span={8}>
            {getDropdownFormItem('displayArea', 'Display Area')}
          </Col>
          <Col span={8}>
            {getInputFormItem('showcaseNumber', 'Showcase Number')}
          </Col>
          <Col span={8}>
            {getInputFormItem('shelfNumber', 'Shelf Number')}
          </Col>
        </Row>
        <Divider/>
        <Row style={rowStyle}>
          {getImageListFormItem('imageList', false, 'objects', imageList, setImageList)}
        </Row>
        <Divider/>
        <Row style={rowStyle}>
          <Col span={12}>
            {getDatePickerFormItem('registrationDate', 'Registration Date')}
          </Col>
          <Col span={12}>
            {getInputFormItem('recordedBy', 'Recorded By')}
          </Col>
        </Row>
        <Divider/>
        {getFormSubmitButton()}
      </Form>
    </CustomAddNewPageContent>
  );
};

export default SaveObject;
